import objectId from 'bson-objectid';

const INITIAL_STATE = {
  data: [],
  currentDash: {
    _id: objectId().str,
    user: localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))._id
      : '',
    name: 'Default',
    transition: true,
    selected: false,
    items: [],
    theme: localStorage.getItem('theme')
      ? localStorage.getItem('theme')
      : 'default-theme'
  },
  sidebarOpen: Boolean(localStorage.getItem('sidebarOpen')),
  enableTransition: false,
  timeTransition: '0005',
  isFetching: false,
  addSuccess: false,
  addError: false,
  editSuccess: false,
  editError: false,
  removeSuccess: false,
  removeError: false,
  selectDefaultSuccess: false,
  selectDefaultError: false,
  getAllError: false,
  errorContent: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'DASHBOARDS_START_REQUEST':
      return {
        ...state,
        isFetching: true,
        addError: false,
        editError: false,
        errorContent: ''
      };
    case 'DASHBOARDS_END_REQUEST':
      return {
        ...state,
        addSuccess: false,
        editSuccess: false,
        removeSuccess: false,
        selectDefaultSuccess: false,
        isFetching: false
      };
    case 'DASHBOARDS_GET_ALL_SUCCESS': {
      if (payload.length && !payload.find(dash => dash.selected)) {
        payload[0].selected = true;
      }
      const dash = payload.find(dash => dash.selected);
      return {
        ...state,
        currentDash:
          dash && !state.enableTransition
            ? dash
            : { ...state.currentDash, selected: true },
        data: payload
      };
    }
    case 'DASHBOARDS_GET_ALL_ERROR':
      return {
        ...state,
        getAllError: true,
        errorContent: payload
      };
    case 'DASHBOARDS_ADD_SUCCESS':
      return {
        ...state,
        data: [payload].concat(state.data),
        addSuccess: true,
        addError: false
      };
    case 'DASHBOARDS_ADD_ERROR':
      return {
        ...state,
        addSuccess: false,
        addError: true,
        errorContent: payload
      };
    case 'DASHBOARDS_EDIT_SUCCESS':
      return {
        ...state,
        data: state.data.map(dash => {
          return dash._id !== payload._id
            ? payload.selected
              ? { ...dash, selected: false }
              : { ...dash }
            : payload;
        }),
        currentDash: payload.selected ? payload : state.currentDash,
        editSuccess: true,
        editError: false
      };
    case 'DASHBOARDS_EDIT_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'DASHBOARDS_REMOVE_SUCCESS':
      return {
        ...state,
        removeSuccess: true,
        removeError: false,
        data: state.data.filter(item => item._id !== payload)
      };
    case 'DASHBOARDS_REMOVE_ERROR':
      return {
        ...state,
        removeSuccess: false,
        removeError: true,
        errorContent: payload
      };
    case 'DASHBOARDS_SELECT_DEFAULT_SUCCESS':
      return {
        ...state,
        data: state.data.map(dash =>
          dash._id !== payload._id ? { ...dash, selected: false } : payload
        ),
        selectDefaultSuccess: true,
        selectDefaultError: false
      };
    case 'DASHBOARDS_SELECT_DEFAULT_ERROR':
      return {
        ...state,
        selectDefaultSuccess: false,
        selectDefaultError: true,
        errorContent: payload
      };
    case 'DASHBOARDS_SIDEBAR_STATE': {
      localStorage.setItem('sidebarOpen', payload || '');
      return {
        ...state,
        sidebarOpen: payload
      };
    }
    case 'DASHBOARDS_MEMBER_TRANSITION_SUCCESS':
      return {
        ...state,
        data: state.data.map(dash =>
          dash._id !== payload._id ? { ...dash } : payload
        ),
        editSuccess: true,
        editError: false
      };
    case 'DASHBOARDS_MEMBER_TRANSITION_ERROR':
      return {
        ...state,
        editSuccess: false,
        editError: true,
        errorContent: payload
      };
    case 'DASHBOARDS_ENABLE_TRANSITION':
      return {
        ...state,
        enableTransition: payload
      };
    case 'DASHBOARDS_TRANSITION_TIME':
      return {
        ...state,
        timeTransition: payload
      };
    case 'DASHBOARDS_SET_CURRENT_DASH':
      return {
        ...state,
        currentDash: payload
      };
    default:
      return { ...state };
  }
};

export default reducer;
